import {Injectable} from '@angular/core';
import Pusher from 'pusher-js';
import {ConfigService} from '../config/config.service';
import {TokenService} from '../token/token.service';
import {ShardHandlerService} from '../sharding/shard-handler.service';
import {Observable} from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class PusherService {

    protected base: string = 'v1/users';
    protected primaryKey: string = 'id';
    protected isReady: Promise<null> = null;
    private pusher: Pusher;

    constructor(
        private configService: ConfigService,
        private tokenService: TokenService,
        public shards: ShardHandlerService,
    ) {
        const vm = this;
        /**
         * Needed, otherwise, pusher will be undefined when subscribe function is called before it is ready,
         * causing an error.
         */
        this.isReady = new Promise((resolve, reject) => {
            const pusherConfig = this.configService.get('pusher');
            const api = this.configService.get('api');

            this.tokenService.get().then((tokens) => {
                const host = api['proto'] + '://' + api['host'] + '/';

                this.pusher = new Pusher(
                    pusherConfig.key, {
                        cluster: pusherConfig.cluster,
                        encrypted: pusherConfig.encrypted,
                        authEndpoint: host + 'v1/broadcasting/auth',
                        auth: {
                            headers: {
                                'Accept': 'application/json',
                                'Authorization': 'Bearer ' + tokens['access_token'],
                                'shard': vm.shards.getAlias(),
                            },
                        },
                    },
                );

                // Might help with debugging if something fails
                this.pusher.connection.bind('error', (err) => {
                    console.warn(err);
                    reject();
                })

                resolve();
            })
        })
    }

    /**
     * Subscribes to a new Pusher connection.
     * Automatically adds private-{{channelname}}. prefix.
     * @param name name in [channelname].{{name}} i.e. if name=user.1: default.user.1
     * @param priv Adds private- prefix, i.e. private-default.user.1
     */
    public subscribe(name, priv = false) {
        return this.isReady.then(() => {
            return this.handleSub(name, priv);
        });
    }

    public unsubscribe(name, priv = false) {
        const api = this.configService.get('api');
        let channelName = this.shards.getAlias() + '.' + name;

        if (priv) {
            channelName = 'private-' + channelName;
        }

        return this.pusher.unsubscribe(channelName);
    }

    // Returns Pusher channel
    private handleSub(name, priv) {
        const api = this.configService.get('api');
        let channelName = this.shards.getAlias() + '.' + name;

        if (priv) {
            channelName = 'private-' + channelName;
        }
        return this.pusher.subscribe(channelName);
    }

}